import React, { Fragment, useState } from 'react';
import { useFetch } from '../../../lib/useFetch';
import { Container, Grid, Table, Card, Button, Page, Dimmer, Avatar } from "tabler-react";
import PaginationBar from '../../../components/pagination';
import SearchInput from '../../../components/searchInput';
import { useParams } from 'react-router-dom';

const Subcategories = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)
  const { id } = useParams()

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`categories/${id}/sub-category?page=${page}${searchParam}`, reload);

  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>Subcategories</Page.Title>
        </Page.Header>
        <Grid>
          <Grid.Row>
            <Card>
              <Dimmer active={loading} loader={loading}>
                <Card.Header>
                  <Card.Options>
                    <SearchInput value={searchQuery} onSubmit={onSearch} />
                  </Card.Options>
                </Card.Header>

                {!loading && (!data || data.length < 1) ? (
                  <div className="alert alert-primary m-0">
                    No Subcategories to show!
                  </div>
                ) : (
                  <div className="table-responsive-wrapper">
                    <Table hasOutline striped>
                      <Table.Header>
                        {['Icon', 'Image', 'Name', 'Price Per Kg', 'Traveller Reward', 'Weight'].map((head, i) => (
                          <Table.ColHeader key={`tableHeader-${i}`}>
                            {head}
                          </Table.ColHeader>
                        ))}
                        <Table.ColHeader>Actions</Table.ColHeader>
                      </Table.Header>
                      <Table.Body>
                        {data && data.map(({ name, image, icon, pricePerKg, minTravelerReward, weight, _id }, i) => (
                          <Table.Row key={i}>
                            <Table.Col>
                              <Avatar size="sm" imageURL={icon} />
                            </Table.Col>

                            <Table.Col>
                              <img width="50" height="50" src={image} alt={name || "Sub-category"} />
                            </Table.Col>

                            <Table.Col>
                              {name}
                            </Table.Col>

                            <Table.Col>
                              {pricePerKg}
                            </Table.Col>

                            <Table.Col>
                              {minTravelerReward}
                            </Table.Col>

                            <Table.Col>
                              {weight}
                            </Table.Col>

                            <Table.Col>
                              <div className="actions-wrap">
                                <Button
                                  outline
                                  color="secondary"
                                  size="sm"
                                  onClick={() => openMainModal('subcategory-edit', _id, () => toggleReload(r => !r))}
                                >
                                  Edit
                                </Button>

                                <Button
                                  outline
                                  color="danger"
                                  className="ml-2"
                                  size="sm"
                                  onClick={() => openMainModal('categories/sub-category--delete', _id, () => toggleReload(r => !r))}
                                >
                                  Delete
                                </Button>
                              </div>
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                )}

                {data && data.length > 0 && (
                  <PaginationBar
                    page={page}
                    totalCount={totalCount}
                    setPage={setPage}
                  />
                )}
              </Dimmer>
            </Card>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
}

export default Subcategories;